'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPlainObject;
// # 判断是否为纯对象，而非object实例 > see: https://code.jquery.com/jquery-3.0.0.js
var class2type = {};
var toString = class2type.toString;
var hasOwn = class2type.hasOwnProperty;
var fnToString = hasOwn.toString;
var ObjectFunctionString = fnToString.call(Object);

function isPlainObject(obj) {
  var proto = void 0;
  var Ctor = void 0;
  // Detect obvious negatives Use toString instead of jQuery.type to catch host
  // objects
  if (!obj || toString.call(obj) !== '[object Object]') {
    return false;
  }

  proto = Object.getPrototypeOf(obj);

  // Objects with no prototype (e.g., `Object.create( null )`) are plain
  if (!proto) {
    return true;
  }

  // Objects with prototype are plain iff they were constructed by a global Object
  // function
  Ctor = hasOwn.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor === 'function' && fnToString.call(Ctor) === ObjectFunctionString;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/isPlainObject.js
// module id = 23
// module chunks = 0